import { useLoaderData, useLocation } from 'react-router-dom'
import { useQueryParams } from 'use-query-params'
import { useState, useEffect } from 'react'
import { useMediaQuery } from '@mui/material'
import Tabs from 'components/Tabs/Tabs'
import SimpleTabs from 'components/SimpleTabs/SimpleTabs'
import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid2'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import { MappedComponent } from 'components'
import CardBase from 'components/Card/CardBase/CardBase'
import Filter from 'components/Filter/Filter'
import BackButton from 'components/BackButton/BackButton'
import ChipsPanel from 'components/ChipsPanel/ChipsPanel'
import NewsletterButton from 'components/NewsletterButton/NewsletterButton'
import { mapQueryParamsType } from 'utils/query/mapQueryParamsType'
import DataGridControls from 'components/DataGridControls/DataGridControls'
import { useGridApiRef } from '@mui/x-data-grid'
import { getPageTitle } from 'layout/navigation'
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline'

function Page() {
  const { data } = useLoaderData()
  const location = useLocation()
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'))
  const [dataGridSelectedRows, setDataGridSelectedRows] = useState([])
  const {
    title = '',
    trackTags = [],
    reportLink = { href: '' },
    periodTabs = { items: [] },
    simpleTabs = { items: [] },
    filters = { all: [], active: [], groups: [] },
    items = [],
    hasNewsletterButton = false,
    hasDataGridControls = false,
  } = data
  const [query] = useQueryParams(mapQueryParamsType(filters ? filters.all : []))
  const dataGridApiRef = useGridApiRef()

  useEffect(() => {
    if (title) {
      document.title = title

      return
    }

    document.title = getPageTitle(location.pathname)
  }, [title, location.pathname])

  return (
    <Stack spacing={3}>
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        spacing={1.6}
        sx={{ alignItems: { xs: 'flex-start', md: 'center' } }}
      >
        <BackButton />
        <Typography component="h1" variant="h1">
          {title}
        </Typography>

        {reportLink.href && (
          <Button
            size="large"
            sx={{
              color: 'primary.light',
              ml: { xs: 0, md: 'auto !important' },
            }}
            endIcon={!isMobile && <DownloadForOfflineIcon />}
            startIcon={isMobile && <DownloadForOfflineIcon />}
            href={reportLink.href}
            download
          >
            Скачать отчет
          </Button>
        )}
      </Stack>

      {trackTags.length ? <ChipsPanel items={trackTags} /> : null}

      {
        (periodTabs.items?.length || hasNewsletterButton) &&
        <Tabs
          {...periodTabs}
          hasNewsletterButton={hasNewsletterButton}
        />
      }

      {
        simpleTabs.items?.length ?
          <SimpleTabs
            {...simpleTabs}
          /> : null
      }

      {filters.all.length ? <Filter filters={filters} /> : null}

      {false ? <NewsletterButton query={query} /> : null}

      {hasDataGridControls ? (
        <DataGridControls
          dataGridSelectedRows={dataGridSelectedRows}
          dataGridApiRef={dataGridApiRef}
        />
      ) : null}

      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={2}>
          {items.map((row) => {
            return row.map(({ component, card, gridSize }, index) => {
              return (
                <Grid
                  key={component.name + index}
                  size={{ xs: 12, lg: gridSize }}
                >
                  <CardBase {...card.props}>
                    <MappedComponent
                      {...(component.name === 'DataGrid'
                        ? {
                            ...component,
                            props: {
                              ...component.props,
                              onRowSelectionChange: setDataGridSelectedRows,
                              dataGridApiRef,
                            },
                          }
                        : component)}
                    />
                  </CardBase>
                </Grid>
              )
            })
          })}
        </Grid>
      </Box>
    </Stack>
  )
}

export default Page
